import React from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Divider,
  Stack,
  Chip
} from "@mui/material";
import { Phone, Email, LocationOn, LinkedIn } from "@mui/icons-material";

const Resume38 = ({ color = "#1a5f7a" }) => {
  // Custom Section Title with a Bottom Border Accent
  const SectionHeader = ({ title }) => (
    <Box sx={{ mb: 2, mt: 3 }}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: 800,
          fontSize: "14px",
          color: color,
          textTransform: "uppercase",
          letterSpacing: "1.5px",
        }}
      >
        {title}
      </Typography>
      <Box sx={{ width: "40px", height: "3px", bgcolor: color, mt: 0.5 }} />
    </Box>
  );

  return (
    <Box
      sx={{
        width: "210mm",
        minHeight: "297mm",
        mx: "auto",
        bgcolor: "#fff",
        boxShadow: "0 0 15px rgba(0,0,0,.1)",
        fontFamily: "'Inter', sans-serif",
        position: "relative",
        borderTop: `10px solid ${color}`, // Top accent bar
      }}
    >
      {/* HEADER SECTION */}
      <Box sx={{ p: 5, pb: 3, display: "flex", alignItems: "center", gap: 4 }}>
        <Avatar
          src="https://via.placeholder.com/200"
          sx={{
            width: 120,
            height: 120,
            borderRadius: "12px", // Square-ish rounded corners
            border: `2px solid #eee`,
          }}
        />
        <Box>
          <Typography variant="h3" fontWeight={900} sx={{ color: "#333", lineHeight: 1 }}>
            SAMIRA HADID
          </Typography>
          <Typography
            variant="h6"
            sx={{ color: color, fontWeight: 500, letterSpacing: 2, mt: 1 }}
          >
            SENIOR HR MANAGER
          </Typography>
          
          <Stack direction="row" spacing={3} mt={2} flexWrap="wrap">
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Phone sx={{ fontSize: 16, color: color }} />
              <Typography fontSize="12px">+123-456-7890</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" gap={0.5}>
              <Email sx={{ fontSize: 16, color: color }} />
              <Typography fontSize="12px">hello@reallygreatsite.com</Typography>
            </Stack>
            <Stack direction="row" alignItems="center" gap={0.5}>
              <LocationOn sx={{ fontSize: 16, color: color }} />
              <Typography fontSize="12px">New York, NY</Typography>
            </Stack>
          </Stack>
        </Box>
      </Box>

      <Divider sx={{ mx: 5 }} />

      <Grid container spacing={0}>
        {/* LEFT MAIN CONTENT */}
        <Grid item  sx={{ p: 5, pt: 2,width:"250px" }}>
          <SectionHeader title="Profile Summary" />
          <Typography fontSize="13px" color="#555" lineHeight={1.7}>
            Results-oriented Human Resources Professional with over 8 years of experience in 
            streamlining HR processes and fostering positive workplace cultures. Proven track 
            record in talent acquisition, employee retention strategies, and organizational development.
          </Typography>

          <SectionHeader title="Work Experience" />
          
          <Box sx={{ borderLeft: `2px solid #eee`, pl: 3, ml: 1 }}>
            <Box sx={{ mb: 3, position: "relative" }}>
              <Box sx={{ position: "absolute", left: "-31px", top: "5px", width: "12px", height: "12px", borderRadius: "50%", bgcolor: color }} />
              <Typography fontWeight={700} fontSize="14px">HR Manager | 2022 – Present</Typography>
              <Typography fontSize="12px" color={color} fontWeight={600} mb={1}>Global Tech Solutions</Typography>
              <Typography fontSize="12.5px" color="#666">
                • Directed full-cycle recruitment for 50+ technical roles. <br/>
                • Implemented a new performance review system that increased engagement by 20%.
              </Typography>
            </Box>

            <Box sx={{ mb: 3, position: "relative" }}>
              <Box sx={{ position: "absolute", left: "-31px", top: "5px", width: "12px", height: "12px", borderRadius: "50%", bgcolor: "#ccc" }} />
              <Typography fontWeight={700} fontSize="14px">Lead Recruiter | 2020 – 2022</Typography>
              <Typography fontSize="12px" color={color} fontWeight={600} mb={1}>Creative Agency Co.</Typography>
              <Typography fontSize="12.5px" color="#666">
                • Reduced time-to-hire by 15 days through automated screening. <br/>
                • Built a diverse talent pipeline focusing on underrepresented groups.
              </Typography>
            </Box>
          </Box>

   
        </Grid>

        {/* RIGHT SIDEBAR CONTENT */}
        <Grid item  sx={{ p: 4, pt: 2, bgcolor: "#f9f9f9", minHeight: "220mm" ,width:"500px"}}>
          <SectionHeader title="Top Skills" />
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {["Strategy", "Talent Sync", "Payroll", "Training", "Relations", "Compliance"].map((skill) => (
              <Chip 
                key={skill} 
                label={skill} 
                size="small" 
                sx={{ 
                  borderRadius: "4px", 
                  bgcolor: "#fff", 
                  border: `1px solid #ddd`,
                  fontSize: "11px",
                  fontWeight: 600
                }} 
              />
            ))}
          </Box>

                 <SectionHeader title="Education" />
          <Typography fontWeight={700} fontSize="14px">Master in Human Resource Management</Typography>
          <Typography fontSize="12px" mb={2}>Any University, Any City | 2017 – 2020</Typography>
          
          <Typography fontWeight={700} fontSize="14px">Bachelor in Business Administration</Typography>
          <Typography fontSize="12px">University, Any City | 2012 – 2017</Typography>

          <SectionHeader title="Languages" />
          <Stack spacing={1}>
            <Box>
              <Typography fontSize="12px" fontWeight={700}>English</Typography>
              <Box sx={{ width: "100%", height: "4px", bgcolor: "#eee", mt: 0.5 }}>
                <Box sx={{ width: "95%", height: "100%", bgcolor: color }} />
              </Box>
            </Box>
            <Box>
              <Typography fontSize="12px" fontWeight={700}>French</Typography>
              <Box sx={{ width: "100%", height: "4px", bgcolor: "#eee", mt: 0.5 }}>
                <Box sx={{ width: "70%", height: "100%", bgcolor: color }} />
              </Box>
            </Box>
          </Stack>

          <SectionHeader title="Reference" />
          <Typography fontSize="12px" fontWeight={700}>Kyrie Petrakis</Typography>
          <Typography fontSize="11px" color="#666">Head Manager, Studio Shodwe</Typography>
          <Typography fontSize="11px" color={color}>+123-456-7890</Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Resume38;

export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: "#1a5f7a", label: "Ocean Blue" },
    { value: "#b22222", label: "Firebrick" },
    { value: "#2d3436", label: "Charcoal" },
    { value: "#6a89cc", label: "Livid" },
  ]
};